'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _hubspot = require('hubspot.PortalIdParser');

var _hubspot2 = _interopRequireDefault(_hubspot);

var _immutable = require('immutable');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _immutable.Record)({
  avatar: null,
  online: false,
  firstName: null,
  lastName: null,
  meetingsLink: null,
  portalId: _hubspot2.default.get(),
  userId: null,
  jobTitle: null,
  aboutMe: null,
  salesPro: false,
  bot: false
}, 'Responder');
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-1.79/js/records/Responder.js
// module id = 58
// module chunks = 0 1